import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { z } from 'zod'
import { LoginPage } from '@/features/auth/components/login-page'

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context, search }) => {
    // Verifica se já está autenticado
    console.log('[Login beforeLoad] Checking auth status...')
    const isAuthenticated = await context.auth.whenReady()
    console.log('[Login beforeLoad] isAuthenticated:', isAuthenticated, 'redirect:', search.redirect)

    if (isAuthenticated) {
      const redirectTo = search.redirect ?? '/home'
      console.log('[Login beforeLoad] Already authenticated, redirecting to:', redirectTo)
      throw redirect({ to: redirectTo })
    }

    console.log('[Login beforeLoad] Not authenticated, showing login page')
  },
  component: LoginRoute,
})

function LoginRoute() {
  const router = useRouter()

  // CORREÇÃO: Navegação mais robusta após login
  const handleLoginSuccess = async () => {
    // SEMPRE redireciona para /home após login (ignora redirect param para evitar loops)
    const redirectTo = '/home'
    console.log('[LoginRoute] Login successful, navigating to:', redirectTo)

    try {
      // Invalida o router para forçar re-avaliação dos guards
      await router.invalidate()
      console.log('[LoginRoute] Router invalidated, now navigating...')

      // Usa window.location para garantir navegação completa
      // Isso evita problemas de race condition com o TanStack Router
      window.location.href = redirectTo
    } catch (error) {
      console.error('[LoginRoute] Navigation error:', error)
      // Fallback: força navegação via window
      window.location.href = redirectTo
    }
  }

  return <LoginPage onSuccess={handleLoginSuccess} />
}
